export const lotColors =
  [
  '#D05B4E',
  '#E57B6E',
  '#EFA78E',
  '#E6A451',
  '#C9BA58',
  '#AFC488',
  '#95C76F',
  '#66C977',
  '#4CB894',
  '#51C8B6',
  '#45B6B4',
  '#3A98C8',
  '#4FA6D8',
  '#4A84CC',
  '#8075B8',
  '#8C7CCF',
  '#A16ACF',
  '#A455B8',
  '#BA6A9F',
  '#C79B92',
  '#9B9BAD',
  '#7C84A3',
  '#6C74A0',
  '#7B7BB3',
  '#8E8EC0'
];
